/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbResourceMapping {
    getFixupPrototypeFunction() { return ServiceNowCmdbResourceMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbResourceMapping>): ServiceNowCmdbResourceMapping {
        let obj = Object.assign(new ServiceNowCmdbResourceMapping(), model);
        ServiceNowCmdbResourceMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbResourceMapping>): ServiceNowCmdbResourceMapping {
        if (!model) return null;
        return ServiceNowCmdbResourceMapping.newInstance(<ServiceNowCmdbResourceMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbResourceMapping) {
        if (!obj) return;

        models.ServiceNowCmdbResourceMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbResourceMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbResourceMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.attribute_mapping) {
            models.ServiceNowCmdbActionResourceMapping.fixupPrototype(this.attribute_mapping);
        }
    }

    /**
     * Resource Category
     */
    resource_category: string;

    /**
     * Resource Type
     */
    resource_type: string;

    /**
     * Resource
     */
    resource: string;

    /**
     * Name of the ServiceNow Cmdb CI Instance Class
     */
    cmdb_ci_class_name: string;

    /**
     * ServiceNow Cmdb CI attributes mapping
     */
    attribute_mapping: models.ServiceNowCmdbActionResourceMapping;

}
